import React, { useState, useEffect } from 'react';
import { getPlayers, getLeague, getTeam, addCaptain, removeCaptain } from '../../data';
import { CircularProgress, makeStyles } from '@material-ui/core';
import {Typography, TextField, Checkbox, Grid, Button, Dialog, DialogTitle, DialogContent,
    Divider } from '@material-ui/core';
import {Table, TableBody, TableCell, TableContainer, TableRow} from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useParams } from "react-router-dom";

function RenderPickedTeam(props) {
    const [saveIcon, setSaveIcon] = useState(false);
    const [removeCaptainSpinner, setRemoveCaptainSpinner] = useState(false);
    const [saveButtonStatus, setSaveButtonStatus] = useState(false);
    const [team, setTeam] = useState({});
    const [message, setMessage] = useState('');
    const [captainToRemove, setCaptainToRemove] = useState(undefined);
    const playerBios = props.playerBios;
    const teamView = props.teamView;
    const getPlayerById = function (id) {
        return playerBios.filter(p => p.id === id)[0];
    };
    const loadTeam = async function() {
        const team = await getTeam(props.leagueID, props.teamID);
        if (!team['captains']) {
            team['captains'] = [];
        }
        setSaveIcon(false);
        setTeam(() => team);
    };
    const getLatestPlayers = function () {
        if (Object.keys(team).length === 0) {
            return [];
        }
        const gameWeeks = Object.keys(team).filter(key => key.startsWith('gw'));
        gameWeeks.sort((e1, e2) => {
            return parseInt(e2.replace('gw', '')) - parseInt(e1.replace('gw', ''));
        });
        const latestGameWeek = gameWeeks[0];
        return team?.[latestGameWeek]?.['players'].map(p => p['id']);
    };
    const setSaveButtonOnInputChange = (e, v, t) => {
        const team = props.teamID;
        const player = document.getElementById('player-picker').value;
        const matchId = document.getElementById('matchId').value;
        setSaveButtonStatus(team != "" && player != "" && matchId != "");
    };
    const removeCaptainHandler = async () => {
        try {
            setRemoveCaptainSpinner(true);
            await removeCaptain(props.leagueID, props.teamID, captainToRemove.matchId, captainToRemove.playerId,
                captainToRemove.triple);
            setRemoveCaptainSpinner(false);
            setCaptainToRemove(undefined);
            loadTeam();
            setMessage(``);
        } catch (err) {
            setMessage(err.message);
            setRemoveCaptainSpinner(false);
            setCaptainToRemove(undefined);
            setMessage(<Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                {err.message}
            </Alert>);
        }
    };
    useEffect(() => {
        loadTeam();
    }, [props.leagueID, props.teamID]);
    if (!team) {
        return <div></div>;
    }
    var tripleUsed = false;
    const latestPlayers = getLatestPlayers() ?? [];
    const playerPicker = (<Autocomplete disablePortal blurOnSelect
        id="player-picker"
        options={playerBios.filter(p => latestPlayers.includes(p.id))}
        onChange={() => setTimeout(setSaveButtonOnInputChange, 100)}
        style={{}}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => <TextField {...params} label="Players" />} />);
    const saveHandler = async function() {
        setSaveIcon(false);
        const playerName = document.getElementById('player-picker').value;
        const players = playerBios
            .filter(p => p['name'].toLocaleLowerCase() === playerName.toLocaleLowerCase());
        if (players && players.length > 1) {
            setMessage(<Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                {`More than one captain: ${JSON.stringify(players)}`}
            </Alert>);
            return;
        }
        if (!players || (players && players.length === 0)) {
            setMessage(<Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                {`Unable to find player`}
            </Alert>);
            return;
        }
        const player = players[0]['id'];
        const matchId = document.getElementById('matchId').value;
        const triple = document.getElementById('triple').checked;
        try {
            setSaveIcon(false);
            await addCaptain(props.leagueID, props.teamID, matchId, player, triple);
            setSaveIcon(true);
            setTimeout(() => document.getElementById('player-picker').value = "", 100);
            document.getElementById('matchId').value = "";
            loadTeam();
            setMessage(``);
            setSaveButtonStatus(false);
        } catch (err) {
            setMessage(err.message);
            setMessage(<Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                {err.message}
            </Alert>);
            setSaveIcon(false);
        }
    };

    const addCaptainToRemove = (matchId, playerId, triple) => {
        setCaptainToRemove({
            matchId,
            playerId,
            triple
        });
    };

    const handleCaptainModalClose = () => {
        setCaptainToRemove(undefined);
    };

    return (
    <TableContainer style={{alignSelf: 'center', flex: 'auto',}}>
    <Table>
        <TableBody>
        {(team['captains'] || []).map(c => {
            const player = getPlayerById(c["player"]);
            const matchId = c["matchId"];
            tripleUsed = tripleUsed || c.triple;
            const showIcon = teamView ? c['editable'] : props.isAdmin;
            const icon = showIcon ? <ClearIcon style={{'cursor': 'pointer'}} onClick={
                () => addCaptainToRemove(matchId, c["player"], !!c.triple)
            } /> : <span></span>;
            const isToBeRemoved = (captainToRemove !== undefined) && (captainToRemove.matchId === matchId)
                && (captainToRemove.playerId === player.id) && (captainToRemove.triple === !!c.triple);
            return (
                <TableRow key={Math.floor((Math.random() * 10000))}>
                    <TableCell>{matchId}</TableCell>
                    <TableCell>{player.name}</TableCell>
                    <TableCell>{c.triple ? "triple": ""}</TableCell>
                    <TableCell>{icon}</TableCell>
                    {captainToRemove !== undefined && isToBeRemoved &&
                    <Dialog key={`${player.id}-${matchId}-exp`} aria-labelledby="simple-dialog-title"
                        open={captainToRemove !== undefined} onClose={handleCaptainModalClose}>
                        <DialogTitle id="simple-dialog-title-">
                            Remove Captain
                        </DialogTitle>
                        <DialogContent dividers>
                            <Typography gutterBottom component="div">
                            MatchID: {matchId}
                            </Typography>
                            <Typography gutterBottom component="div">
                            Player: {player.name}
                            </Typography>
                            <Typography gutterBottom component="div">
                            Triple: {c.triple ? "YES" : "NO"}
                            </Typography>
                            <Divider />
                            <Button variant='contained' color='primary' onClick={removeCaptainHandler}
                                style={{'marginTop': '10px'}}>
                                Remove
                            </Button>
                            {removeCaptainSpinner && <CircularProgress />}
                        </DialogContent>
                    </Dialog>}
                </TableRow>
            )
        })}
        <TableRow>
            <TableCell></TableCell>
            <TableCell>{message}</TableCell>
            <TableCell></TableCell>
        </TableRow>
        <TableRow>
            <TableCell><TextField label="matchId" id="matchId" onChange={setSaveButtonOnInputChange} /></TableCell>
            <TableCell>{playerPicker}</TableCell>
            <TableCell>Triple:
                {!tripleUsed && <Checkbox name="triple" id="triple" />}
                {tripleUsed && <Checkbox name="triple" id="triple" disabled />}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
                <Button variant='contained' color='primary' onClick={saveHandler} disabled={!saveButtonStatus}>
                    Save
                </Button>
            </TableCell>
            <TableCell>
                {saveIcon && <CheckIcon />}
            </TableCell>
        </TableRow>
        </TableBody>
    </Table>
    </TableContainer>);
}

export default function Captains(props) {
    const [loading, setLoading] = useState(true);
    const [playerBios, setPlayerBios] = useState([]);
    const [squad, setSquad] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [pickedTeam, setPickedTeam] = useState(undefined);
    const [teamView, setTeamView] = useState(false);

    let {leagueID, teamID} = useParams();
    useEffect(() => {
        (async function() {
            const league = await getLeague(leagueID);
            setSquad(league['teams']);
            setIsAdmin(league['isAdmin']);
            const playerData = await getPlayers(league.tournament, leagueID);
            setPlayerBios(playerData['players']);
            setLoading(false);
            if (teamID !== undefined) {
                setPickedTeam({name: teamID});
                setTeamView(true);
            }
        })();
    }, [leagueID, teamID]);

    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            justifyContent: 'center',
            padding: theme.spacing(1),
        },
        grid: {
            maxWidth: 600,
            alignSelf: 'center',
            flex: 'auto',
            justifyContent: 'center',
            overflow: 'auto',
        },
        paper: {
            padding: theme.spacing(2),
            textAlign: 'center',
            color: theme.palette.text.secondary,
          },
    }));
    const classes = useStyles();
    const teams = squad.map(s => {
        return s;
    });
    const teamPickHandler = function(event, value) {
        setPickedTeam(value);
    };
    const teamPicker = (<Autocomplete disablePortal blurOnSelect
        id="team-picker"
        options={teams}
        style={{ width: 300 }}
        onChange={teamPickHandler}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => <TextField {...params} label="Team" />} />);
    
    return (
        <div className={classes.root}>
            <div className={classes.grid}>
                <div>
                    {loading && <CircularProgress />}
                </div>
                <div>
                    {!loading && !teamView && teamPicker}
                    {!loading && teamView &&
                        <Typography variant="h6">Captains - {teamID}</Typography>}
                </div>
                <div style={{justifyContent: 'center',}}>
                    {pickedTeam && <RenderPickedTeam leagueID={leagueID} teamID={pickedTeam['name']}
                        playerBios={playerBios} isAdmin={isAdmin} teamView={teamView} />}
                </div>
            </div>
        </div>
    )
}